export default __webpack_public_path__ + "static/media/blogIndex3.472abbb2.png";